import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
// main.ts
// 如果您正在使用CDN引入，请删除下面一行。
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

 

const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
  
// 将store注入到全局
app.provide('$store', store);
 
// 或者使用Vue 3的组合式API
app.config.globalProperties.$store = store;

app.use(ElementPlus)

// 创建并挂载Vue根实例
app.use(store).use(router).mount('#app');